import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import TitleBlock from '../TitleBlock';
import { AiOutlineWifi } from 'react-icons/ai';
import { TbSwimming } from 'react-icons/tb';
import { MdOutlineFastfood } from 'react-icons/md';
import { IoIosPeople } from 'react-icons/io';
import { GiFlowerPot } from 'react-icons/gi';
import { BiBed } from 'react-icons/bi';

const Amenities = () => {
  return (
    <div>
    {window.location.href.includes("branch")?
  "":
  
    <TitleBlock
      number='04'
      pretitle='FEATURES'
      title='amenities'
      desc='Lorem ipsum dolor, sit amet consectetur adipisicing elit. Voluptate
        aliquid nesciunt pariatur reprehenderit, possimus labore eligendi
        beatae facilis eum maiores.'
    />
  
 
  }

      <section>
        <Container>
          <Row>
            <Col md={2} sm={6} xs={6}>
              <section className='animitiesBox'>
                <AiOutlineWifi />
                <div className='animitiesBox-title'>Wi-Fi</div>
              </section>
            </Col>
            <Col md={2} sm={6} xs={6}>
              <section className='animitiesBox'>
                <TbSwimming />
                <div className='animitiesBox-title'>Swimming Pool</div>
              </section>
            </Col>
            <Col md={2} sm={6} xs={6}>
              <section className='animitiesBox'>
                <MdOutlineFastfood />
                <div className='animitiesBox-title'>Delicious Food</div>
              </section>
            </Col>
            <Col md={2} sm={6} xs={6}>
              <section className='animitiesBox'>
                <IoIosPeople />
                <div className='animitiesBox-title'>Seminar Hall</div>
              </section>
            </Col>
            <Col md={2} sm={6} xs={6}>
              <section className='animitiesBox'>
                <GiFlowerPot />
                <div className='animitiesBox-title'>Garden</div>
              </section>
            </Col>
            <Col md={2} sm={6} xs={6}> 
              <section className='animitiesBox'>
                <BiBed />
                <div className='animitiesBox-title'>Luxurious Room</div>
              </section>
            </Col>
            <Col md={2} sm={6} xs={6}>
              <section className='animitiesBox'>
                <AiOutlineWifi />
                <div className='animitiesBox-title'>Wi-Fi</div>
              </section>
            </Col>
            <Col md={2} sm={6} xs={6}>
              <section className='animitiesBox'>
                <AiOutlineWifi />
                <div className='animitiesBox-title'>Wi-Fi</div>
              </section>
            </Col>
            <Col md={2} sm={6} xs={6}>
              <section className='animitiesBox'>
                <AiOutlineWifi />
                <div className='animitiesBox-title'>Wi-Fi</div>
              </section>
            </Col>
            <Col md={2} sm={6} xs={6}>
              <section className='animitiesBox'>
                <AiOutlineWifi />
                <div className='animitiesBox-title'>Wi-Fi</div>
              </section>
            </Col>
            <Col md={2} sm={6} xs={6}>
              <section className='animitiesBox'>
                <AiOutlineWifi />
                <div className='animitiesBox-title'>Wi-Fi</div>
              </section>
            </Col>
            <Col md={2} sm={6} xs={6}>
              <section className='animitiesBox'>
                <AiOutlineWifi />
                <div className='animitiesBox-title'>Wi-Fi</div>
              </section>
            </Col>
          </Row>
        </Container>
      </section>
    </div>
  );
};

export default Amenities;
